export const Data = [
  {
    type:"zh",
    content:{
      showimg:false,
      language:[
        {
          text1:{
            type:"text",
            content:"中文"
          },
          path:{
            type:"text",
            content:"zh"
          }
        },
        {
          text1:{
            type:"text",
            content:"English"
          },
          path:{
            type:"text",
            content:"en"
          }
        },
      ],
      activeIndex:1,
      menuData:[{
        headIndex: {
          type:"int",
          content:"1"
        },
        headText:{
          type:"text",
          content:"首页"
        },
        headPath:{
          type:"text",
          content:"/"
        },
      },
        {
          headIndex: {
            type:"int",
            content:"2"
          },
          headText:{
            type:"text",
            content:"产品技术"
          },
          headPath:{
            type:"text",
            content:"/product"
          },
        },
        {
          headIndex: {
            type:"int",
            content:"3"
          },
          headText:{
            type:"text",
            content:"解决方案"
          },
          headPath:{
            type:"text",
            content:"/solution"
          },
        },
        {
          headIndex: {
            type:"int",
            content:"4"
          },
          headText:{
            type:"text",
            content:"关于我们"
          },
          headPath:{
            type:"text",
            content:"/aboutUs"
          },
        },
        {
          headIndex: {
            type:"int",
            content:"5"
          },
          headText:{
            type:"text",
            content:"联系我们"
          },
          headPath:{
            type:"text",
            content:"/contactUs"
          },
        },
        {
          headIndex: {
            type:"int",
            content:"6"
          },
          headText:{
            type:"text",
            content:"新闻中心"
          },
          headPath:{
            type:"text",
            content:"/news2"
          },
        }
      ]
    }
  },
  {
    type: "en",
    content: {
      showimg: false,
      language: [
        {
          text1:{
            type:"text",
            content:"中文"
          },
          path:{
            type:"text",
            content:"zh"
          }
        },
        {
          text1:{
            type:"text",
            content:"English"
          },
          path:{
            type:"text",
            content:"en"
          }
        },
      ],
      activeIndex: 1,
      menuData: [{
        headIndex: {
          type: "int",
          content: 1
        },
        headText: {
          type: "text",
          content: "Home"
        },
        headPath: {
          type: "text",
          content: "/"
        },
      },
        {
          headIndex: {
            type: "int",
            content: 2
          },
          headText: {
            type: "text",
            content: "Product & Technology"
          },
          headPath: {
            type: "text",
            content: "/product"
          },
        },
        {
          headIndex: {
            type: "int",
            content: 3
          },
          headText: {
            type: "text",
            content: "Solutions"
          },
          headPath: {
            type: "text",
            content: "/solution"
          },
        },
        {
          headIndex: {
            type: "int",
            content: 4
          },
          headText: {
            type: "text",
            content: "About Us"
          },
          headPath: {
            type: "text",
            content: "/aboutUs"
          },
        },
        {
          headIndex: {
            type: "int",
            content: 5
          },
          headText: {
            type: "text",
            content: "Contact Us"
          },
          headPath: {
            type: "text",
            content: "/contactUs"
          },
        },
        // {
        //   headIndex: {
        //     type: "int",
        //     content: 6
        //   },
        //   headText: {
        //     type: "text",
        //     content: "News Center"
        //   },
        //   headPath: {
        //     type: "text",
        //     content: "/news2"
        //   },
        // }
      ]
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/js/header.js